import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AppCookieService {
  private cookieStore: { [key: string]: string } = {};

  constructor() {
    this.parseCookies();
  }

  /**
   * Parses document.cookie into an object
   */
  private parseCookies() {
    this.cookieStore = {};
    if (!document.cookie) return;
    
    const cookiesArr = document.cookie.split('; ');
    for (const cookie of cookiesArr) {
      const [key, ...valArr] = cookie.split('=');
      this.cookieStore[key.trim()] = decodeURIComponent(valArr.join('='));
    }
  }

  /**
   * Get a cookie by key
   */
  get(key: string): string | null {
    this.parseCookies(); // Ensure latest cookies are read
    return this.cookieStore[key] || null;
  }

  /**
   * Set a cookie with additional options
   */
  set(key: string, value: string, days: number = 7, path: string = '/') {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    
    document.cookie = `${key}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=${path}; SameSite=Lax`;
  }

  /**
   * Remove a cookie
   */
  remove(key: string, path: string = '/') {
    console.log("Removing cookie:", key);
    
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; SameSite=Lax`;
    
    console.log("Cookie value after removal:", this.get(key)); // Should return null
  }
}
